<template>
  <div>
    <PageAllow controller="Suppliers" action="supplierScore" />
    <Breadcrumbs :items="items" />
    <v-slide-x-transition>
      <v-sheet class="transparent-background-color">
        <v-row dense class="mx-5">
          <v-col cols="12" sm="12" md="4">
            <v-row dense align="center" class="pa-1">
              <SearcherDatetimeRangeWithRadio
                v-model="datetimeRage"
                type="date"
                :label="$t('StockPosition.Fields.create')"
                removeIcon
              />
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="8" align-self="center">
            <v-row dense align="center" class="search-controls">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="px-0 py-0 caption font-weight-bold grey--text"
                    color="primary"
                    @click.stop="onSearch()"
                  >
                    <v-icon small class="pe-1">fa-search</v-icon>
                    {{ $t("Search.search") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.searchTip") }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="caption font-weight-bold grey--text"
                    @click.stop="resetSearch()"
                  >
                    <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                    {{ $t("Search.reset") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.resetTip") }}</span>
              </v-tooltip>
              <v-spacer />
              <!-- 导出 -->
              <v-btn
                v-if="$permission.permissionAllow('Suppliers', 'supplierComplaintImport')"
                small
                color="print"
                dark
                @click.stop="ImportDialog = true"
                class="ms-1"
              >
                <v-icon x-small class="pe-1">fa-file-import</v-icon>
                {{ $t("supplierScore.import") }}
              </v-btn>
              <v-btn
                v-if="$permission.permissionAllow('Suppliers', 'supplierScoreExport')"
                small
                color="print"
                dark
                @click="exports()"
                class="ms-1"
              >
                <v-icon x-small class="pe-1">fa-file-export</v-icon>
                {{ $t("supplierScore.export") }}
              </v-btn>
            </v-row>
          </v-col>
        </v-row>
        <v-row class="mx-2 my-1">
          <!-- 供应商等级 -->
          <v-col cols="12" sm="6" md="4">
            <v-card class="mt-6">
              <v-card-title>
                <a @click="$router.push('/supplier-score/detail/')">
                  {{ $t("supplierScore.level_num.title") }}
                </a>
              </v-card-title>
              <v-divider />
              <v-card-text>
                <div id="level_num_chart" style="height: 45vh"></div>
              </v-card-text>
              <v-col class="pl-10">
                <div>
                  <a @click="$router.push('/supplier-score/detail/')">
                  <span>
                    {{ $t("supplierScore.level_num.A_text") }}
                    <span style="color:#0A9A8D">
                      {{ level_num.level_A_count ? level_num.level_A_count : 0 }}
                    </span>
                  </span>
                  </a>
                </div>
                <div class="mt-5">
                  <a @click="$router.push('/supplier-score/detail/')">
                    <span>
                      {{ $t("supplierScore.level_num.B_text") }}
                      <span style="color:#FFA014;">
                        {{ level_num.level_B_count ? level_num.level_B_count : 0 }}
                      </span>
                    </span>
                  </a>
                </div>
                <div class="mt-5">
                  <a @click="$router.push('/supplier-score/detail/')">
                    <span>
                      {{ $t("supplierScore.level_num.C_text") }}
                      <span style="color:#FF5E2B;">
                        {{ level_num.level_C_count ? level_num.level_C_count : 0 }}
                      </span>
                    </span>
                  </a>
                </div>
                <div class="mt-5">
                  <a @click="$router.push('/supplier-score/detail/')">
                    <span>
                      {{ $t("supplierScore.level_num.D_text") }}
                      <span style="color:#F44A3E;">
                        {{ level_num.level_D_count ? level_num.level_D_count : 0 }}
                      </span>
                    </span>
                  </a>
                </div>
              </v-col>
            </v-card>
          </v-col>
          <!-- 订单平均满足率 -->
          <v-col cols="12" sm="6" md="4">
            <v-card class="mt-6">
              <v-card-title>
                <a @click="$router.push('/supplier-score/detail/')">
                  {{ $t("supplierScore.level_satisfaction.title", [level_satisfaction.total_satisfaction_avg ? (level_satisfaction.total_satisfaction_avg * 100).toFixed(2) : 0]) }}
                </a>
              </v-card-title>
              <v-divider />
              <v-card-text>
                <div id="level_satisfaction_chart" style="height: 45vh"></div>
              </v-card-text>
              <v-col class="pl-10">
                <div>
                  <a @click="$router.push('/supplier-score/detail/')">
                    <span>
                      {{ $t("supplierScore.level_satisfaction.A_text") }}
                      <span style="color:#0A9A8D">
                        {{ level_satisfaction.level_A_satisfaction_avg ? (level_satisfaction.level_A_satisfaction_avg * 100).toFixed(2) : 0 }}
                        {{ $t("Global.rate") }}
                      </span>
                    </span>
                  </a>
                </div>
                <div class="mt-5">
                  <a @click="$router.push('/supplier-score/detail/')">
                    <span>
                      {{ $t("supplierScore.level_satisfaction.B_text") }}
                      <span style="color:#FFA014;">
                        {{ level_satisfaction.level_B_satisfaction_avg ? (level_satisfaction.level_B_satisfaction_avg * 100).toFixed(2) : 0 }}
                        {{ $t("Global.rate") }}
                      </span>
                    </span>
                  </a>
                </div>
                <div class="mt-5">
                  <a @click="$router.push('/supplier-score/detail/')">
                    <span>
                      {{ $t("supplierScore.level_satisfaction.C_text") }}
                      <span style="color:#FF5E2B;">
                        {{ level_satisfaction.level_C_satisfaction_avg ? (level_satisfaction.level_C_satisfaction_avg * 100).toFixed(2) : 0 }}
                        {{ $t("Global.rate") }}
                      </span>
                    </span>
                  </a>
                </div>
                <div class="mt-5">
                  <a @click="$router.push('/supplier-score/detail/')">
                    <span>
                      {{ $t("supplierScore.level_satisfaction.D_text") }}
                      <span style="color:#F44A3E;">
                        {{ level_satisfaction.level_D_satisfaction_avg ? (level_satisfaction.level_D_satisfaction_avg * 100).toFixed(2) : 0 }}
                        {{ $t("Global.rate") }}
                      </span>
                    </span>
                  </a>
                </div>
              </v-col>
            </v-card>
          </v-col>
          <!-- 价格负向波动平均频次 -->
          <v-col cols="12" sm="6" md="4">
            <v-card class="mt-6">
              <v-card-title>
                <a @click="$router.push('/supplier-score/detail/')">
                  {{ $t("supplierScore.level_fluctuation.title", [level_fluctuation.total_fluctuation_avg ? level_fluctuation.total_fluctuation_avg : 0]) }}
                </a>
              </v-card-title>
              <v-divider />
              <v-card-text>
                <div id="level_fluctuation_chart" style="height: 45vh"></div>
              </v-card-text>
              <v-col class="pl-10">
                <div>
                  <a @click="$router.push('/supplier-score/detail/')">
                    <span>
                      {{ $t("supplierScore.level_fluctuation.A_text") }}
                      <span style="color:#0A9A8D">
                        {{ level_fluctuation.level_A_fluctuation_avg ? level_fluctuation.level_A_fluctuation_avg : 0 }}
                        {{ $t("Global.times") }}
                      </span>
                    </span>
                  </a>
                </div>
                <div class="mt-5">
                  <a @click="$router.push('/supplier-score/detail/')">
                    <span>
                      {{ $t("supplierScore.level_fluctuation.B_text") }}
                      <span style="color:#FFA014;">
                        {{ level_fluctuation.level_B_fluctuation_avg ? level_fluctuation.level_B_fluctuation_avg : 0 }}
                        {{ $t("Global.times") }}
                      </span>
                    </span>
                  </a>
                </div>
                <div class="mt-5">
                  <a @click="$router.push('/supplier-score/detail/')">
                    <span>
                      {{ $t("supplierScore.level_fluctuation.C_text") }}
                      <span style="color:#FF5E2B;">
                        {{ level_fluctuation.level_C_fluctuation_avg ? level_fluctuation.level_C_fluctuation_avg : 0 }}
                        {{ $t("Global.times") }}
                      </span>
                    </span>
                  </a>
                </div>
                <div class="mt-5">
                  <a @click="$router.push('/supplier-score/detail/')">
                    <span>
                      {{ $t("supplierScore.level_fluctuation.D_text") }}
                      <span style="color:#F44A3E;">
                        {{ level_fluctuation.level_D_fluctuation_avg ? level_fluctuation.level_D_fluctuation_avg : 0 }}
                        {{ $t("Global.times") }}
                      </span>
                    </span>
                  </a>
                </div>
              </v-col>
            </v-card>
          </v-col>
          <!-- 质量平均合格率 -->
          <v-col cols="12" sm="6" md="4">
            <v-card class="mt-6">
              <v-card-title>
                <a @click="$router.push('/supplier-score/detail/')">
                  {{ $t("supplierScore.level_qualification.title", [level_qualification.total_qualification_avg ? (level_qualification.total_qualification_avg * 100).toFixed(2) : 0]) }}
                </a>
              </v-card-title>
              <v-divider />
              <v-card-text>
                <div id="level_qualification_chart" style="height: 45vh"></div>
              </v-card-text>
              <v-col class="pl-10">
                <div>
                  <a @click="$router.push('/supplier-score/detail/')">
                    <span>
                      {{ $t("supplierScore.level_qualification.A_text") }}
                      <span style="color:#0A9A8D">
                        {{ level_qualification.level_A_qualification_avg ? (level_qualification.level_A_qualification_avg * 100).toFixed(2) : 0 }}
                        {{ $t("Global.rate") }}
                      </span>
                    </span>
                  </a>
                </div>
                <div class="mt-5">
                  <a @click="$router.push('/supplier-score/detail/')">
                    <span>
                      {{ $t("supplierScore.level_qualification.B_text") }}
                      <span style="color:#FFA014;">
                        {{ level_qualification.level_B_qualification_avg ? (level_qualification.level_B_qualification_avg * 100).toFixed(2) : 0 }}
                        {{ $t("Global.rate") }}
                      </span>
                    </span>
                  </a>
                </div>
                <div class="mt-5">
                  <a @click="$router.push('/supplier-score/detail/')">
                    <span>
                      {{ $t("supplierScore.level_qualification.C_text") }}
                      <span style="color:#FF5E2B;">
                        {{ level_qualification.level_C_qualification_avg ? (level_qualification.level_C_qualification_avg * 100).toFixed(2) : 0 }}
                        {{ $t("Global.rate") }}
                      </span>
                    </span>
                  </a>
                </div>
                <div class="mt-5">
                  <a @click="$router.push('/supplier-score/detail/')">
                    <span>
                      {{ $t("supplierScore.level_qualification.D_text") }}
                      <span style="color:#F44A3E;">
                        {{ level_qualification.level_D_qualification_avg ? (level_qualification.level_D_qualification_avg * 100).toFixed(2) : 0 }}
                        {{ $t("Global.rate") }}
                      </span>
                    </span>
                  </a>
                </div>
              </v-col>
            </v-card>
          </v-col>
          <!-- 到货平均及时率 -->
          <v-col cols="12" sm="6" md="4">
            <v-card class="mt-6">
              <v-card-title>
                <a @click="$router.push('/supplier-score/detail/')">
                  {{ $t("supplierScore.level_timeliness.title", [level_timeliness.total_timeliness_avg ? (level_timeliness.total_timeliness_avg * 100).toFixed(2) : 0]) }}
                </a>
              </v-card-title>
              <v-divider />
              <v-card-text>
                <div id="level_timeliness_chart" style="height: 45vh"></div>
              </v-card-text>
              <v-col class="pl-10">
                <div>
                  <a @click="$router.push('/supplier-score/detail/')">
                    <span>
                      {{ $t("supplierScore.level_timeliness.A_text") }}
                      <span style="color:#0A9A8D">
                        {{ level_timeliness.level_A_timeliness_avg ? (level_timeliness.level_A_timeliness_avg * 100).toFixed(2) : 0 }}
                        {{ $t("Global.rate") }}
                      </span>
                    </span>
                  </a>
                </div>
                <div class="mt-5">
                  <a @click="$router.push('/supplier-score/detail/')">
                    <span>
                      {{ $t("supplierScore.level_timeliness.B_text") }}
                      <span style="color:#FFA014;">
                        {{ level_timeliness.level_B_timeliness_avg ? (level_timeliness.level_B_timeliness_avg * 100).toFixed(2): 0 }}
                        {{ $t("Global.rate") }}
                      </span>
                    </span>
                  </a>
                </div>
                <div class="mt-5">
                  <a @click="$router.push('/supplier-score/detail/')">
                    <span>
                      {{ $t("supplierScore.level_timeliness.C_text") }}
                      <span style="color:#FF5E2B;">
                        {{ level_timeliness.level_C_timeliness_avg ? (level_timeliness.level_C_timeliness_avg * 100).toFixed(2) : 0 }}
                        {{ $t("Global.rate") }}
                      </span>
                    </span>
                  </a>
                </div>
                <div class="mt-5">
                  <a @click="$router.push('/supplier-score/detail/')">
                    <span>
                      {{ $t("supplierScore.level_timeliness.D_text") }}
                      <span style="color:#F44A3E;">
                        {{ level_timeliness.level_D_timeliness_avg ? (level_timeliness.level_D_timeliness_avg * 100).toFixed(2) : 0 }}
                        {{ $t("Global.rate") }}
                      </span>
                    </span>
                  </a>
                </div>
              </v-col>
            </v-card>
          </v-col>
          <!-- 供应商平均考核评分 -->
          <v-col cols="12" sm="6" md="4">
            <v-card class="mt-6">
              <v-card-title>
                <a @click="$router.push('/supplier-score/detail/')">
                  {{ $t("supplierScore.level_score.title", [level_score.total_score_avg ? level_score.total_score_avg : 0]) }}
                </a>
              </v-card-title>
              <v-divider />
              <v-card-text>
                <div id="level_score_chart" style="height: 45vh"></div>
              </v-card-text>
              <v-col class="pl-10">
                <div>
                  <a @click="$router.push('/supplier-score/detail/')">
                    <span>
                      {{ $t("supplierScore.level_score.A_text") }}
                      <span style="color:#0A9A8D">
                        {{ level_score.level_A_score_avg ? level_score.level_A_score_avg : 0 }}
                      </span>
                    </span>
                  </a>
                </div>
                <div class="mt-5">
                  <a @click="$router.push('/supplier-score/detail/')">
                    <span>
                      {{ $t("supplierScore.level_score.B_text") }}
                      <span style="color:#FFA014;">
                        {{ level_score.level_B_score_avg ? level_score.level_B_score_avg : 0 }}
                      </span>
                    </span>
                  </a>
                </div>
                <div class="mt-5">
                  <a @click="$router.push('/supplier-score/detail/')">
                    <span>
                      {{ $t("supplierScore.level_score.C_text") }}
                      <span style="color:#FF5E2B;">
                        {{ level_score.level_C_score_avg ? level_score.level_C_score_avg : 0 }}
                      </span>
                    </span>
                  </a>
                </div>
                <div class="mt-5">
                  <a @click="$router.push('/supplier-score/detail/')">
                    <span>
                      {{ $t("supplierScore.level_score.D_text") }}
                      <span style="color:#F44A3E;">
                        {{ level_score.level_D_score_avg ? level_score.level_D_score_avg : 0 }}
                      </span>
                    </span>
                  </a>
                </div>
              </v-col>
            </v-card>
          </v-col>
        </v-row>
      </v-sheet>
    </v-slide-x-transition>
    <ImportExcelAlert
      v-model="ImportDialog"
      :objName="$t('supplierScore.qualification')"
      hideDownload
      @import="
        excelFile = $event;
        importExcel();
      "
    />
  </div>
</template>

<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import Suppliers from "@/api/suppliers";
import SearcherDatetimeRangeWithRadio from "@/components/plugins/SearcherDatetimeRangeWithRadio";
import ImportExcelAlert from "@/components/plugins/ImportExcelAlert";
import * as echarts from "echarts";

const defaultOptions = {
  finish_date_from:
    new Date(new Date().getTime() - 30 * 24 * 3600 * 1000)
      .toISOString()
      .substr(0, 10),
  finish_date_to: new Date().toISOString().substr(0, 10),
};

export default {

  components: {
    PageAllow,
    Breadcrumbs,
    SearcherDatetimeRangeWithRadio,
    ImportExcelAlert
  },

  computed: {
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("Nav.supplier"),
        disabled: false,
        href: "/supplier",
      },
      {
        text: i18n.t("Nav.supplierScore"),
        disabled: true,
        href: "/supplier",
      },
    ],
    // ordersCountByHourValue() {
    //   return this.cutHoursData(this.ordersByHour, "orders_total_count", 3);
    // },
    // ordersTotalByHourValue() {
    //   return this.cutHoursData(
    //     this.ordersByHour,
    //     "orders_total_order_price",
    //     3
    //   );
    // },
    // stockOrdersCountByHourValue() {
    //   return this.cutHoursData(this.stockOrdersByHour, "total_count", 3);
    // },
    // materialTabTitles() {
    //   var titles = [];
    //   if (this.settings && this.settings.push_platform_setting) {
    //     titles.push({
    //       title: i18n.t("Top.PushError.title"),
    //     });
    //   }
    //   if (this.settings) {
    //     titles.push(
    //       { title: i18n.t("Top.nearday_materials") },
    //       { title: i18n.t("Top.expired_materials") },
    //       { title: i18n.t("Top.noOrderShopsWarning") }
    //     );
    //     if (this.maxStockMaterials.length) {
    //       titles.push({
    //         title: i18n.t("Top.max_stock_materials"),
    //       });
    //     }
    //     if (this.minStockMaterials.length) {
    //       titles.push({
    //         title: i18n.t("Top.min_stock_materials"),
    //       });
    //     }
    //     if (this.neardayShops.length) {
    //       titles.push({
    //         title: i18n.t("Top.nearday_shop_psi"),
    //       });
    //     }
    //     if (this.expiredShops.length) {
    //       titles.push({
    //         title: i18n.t("Top.expired_shop_psi"),
    //       });
    //     }
    //   }
    //   return titles;
    // },
    // neardayMaterialsHeaders: () => [
    //   {
    //     text: i18n.t("Top.materialsFields.material_code"),
    //     align: "start",
    //     value: "material.material_code",
    //   },
    //   {
    //     text: i18n.t("Top.materialsFields.material_name"),
    //     align: "start",
    //     value: "material.material_name",
    //   },
    //   {
    //     text: i18n.t("Top.materialsFields.stock_name"),
    //     align: "center",
    //     value: "stock.name",
    //   },
    //   {
    //     text: i18n.t("Top.materialsFields.stock_max"),
    //     align: "center",
    //     value: "stock_material.stock_max",
    //   },
    //   {
    //     text: i18n.t("Top.materialsFields.stock_min"),
    //     align: "center",
    //     value: "stock_material.stock_min",
    //   },
    //   {
    //     text: i18n.t("Top.materialsFields.stock_in_order_code"),
    //     align: "center",
    //     value: "stock_in_order_code",
    //   },
    //   {
    //     text: i18n.t("Top.materialsFields.nearday_count"),
    //     align: "center",
    //     value: "stock_current",
    //   },
    //   {
    //     text: i18n.t("Top.materialsFields.nearday"),
    //     align: "center",
    //     value: "expired_date",
    //   },
    // ],
    // pushErrorHeaders: () => [
    //   {
    //     text: i18n.t("Top.PushError.pushErrorFields.order_code"),
    //     align: "start",
    //     value: "order_code",
    //     sortable: false,
    //   },
    //   {
    //     text: i18n.t("Top.PushError.pushErrorFields.err_msg"),
    //     align: "center",
    //     value: "err_msg",
    //     sortable: false,
    //   },
    // ],
    // errorsHeaders: () => [
    //   {
    //     text: i18n.t("Top.PushError.Fields.err_msg"),
    //     align: "start",
    //     value: "error_msg",
    //     sortable: false,
    //   },
    //   {
    //     text: i18n.t("Top.PushError.deliveryErrorFields.order_code"),
    //     align: "center",
    //     value: "order_code",
    //     sortable: false,
    //   },
    //   {
    //     text: i18n.t("Top.PushError.Fields.actions"),
    //     align: "end",
    //     value: "actions",
    //     sortable: false,
    //   },
    // ],
    // expiredMaterialsHeaders: () => [
    //   {
    //     text: i18n.t("Top.materialsFields.material_code"),
    //     align: "start",
    //     value: "material.material_code",
    //   },
    //   {
    //     text: i18n.t("Top.materialsFields.material_name"),
    //     align: "start",
    //     value: "material.material_name",
    //   },
    //   {
    //     text: i18n.t("Top.materialsFields.stock_name"),
    //     align: "center",
    //     value: "stock.name",
    //   },
    //   {
    //     text: i18n.t("Top.materialsFields.stock_max"),
    //     align: "center",
    //     value: "stock_material.stock_max",
    //   },
    //   {
    //     text: i18n.t("Top.materialsFields.stock_min"),
    //     align: "center",
    //     value: "stock_material.stock_min",
    //   },
    //   {
    //     text: i18n.t("Top.materialsFields.stock_in_order_code"),
    //     align: "center",
    //     value: "stock_in_order_code",
    //   },
    //   {
    //     text: i18n.t("Top.materialsFields.expired_count"),
    //     align: "center",
    //     value: "stock_current",
    //   },
    //   {
    //     text: i18n.t("Top.materialsFields.expired"),
    //     align: "center",
    //     value: "expired_date",
    //   },
    // ],
    // noOrderShopsHeaders: () => [
    //   {
    //     text: i18n.t("Top.NoOrderShopsFields.shop_code"),
    //     align: "start",
    //     value: "shop_code",
    //   },
    //   {
    //     text: i18n.t("Top.NoOrderShopsFields.shop_name"),
    //     align: "start",
    //     value: "shop_name",
    //   },
    //   {
    //     text: i18n.t("Top.NoOrderShopsFields.shop_user_name"),
    //     align: "start",
    //     value: "shop_user_name",
    //   },
    //   {
    //     text: i18n.t("Top.NoOrderShopsFields.lastOrderCreated"),
    //     align: "start",
    //     value: "lastOrderCreated",
    //   },
    //   {
    //     text: i18n.t("Top.NoOrderShopsFields.noOrderDays"),
    //     align: "start",
    //     value: "noOrderDays",
    //   },
    // ],
    // maxStockMaterialsHeaders: () => [
    //   {
    //     text: i18n.t("Top.materialsFields.material_code"),
    //     align: "start",
    //     value: "material_code",
    //   },
    //   {
    //     text: i18n.t("Top.materialsFields.material_name"),
    //     align: "start",
    //     value: "material_name",
    //   },
    //   {
    //     text: i18n.t("Top.materialsFields.stock_name"),
    //     align: "center",
    //     value: "stock.name",
    //   },
    //   {
    //     text: i18n.t("Top.materialsFields.max_stock_num"),
    //     align: "center",
    //     value: "stock_max",
    //   },
    //   {
    //     text: i18n.t("Top.materialsFields.stock_num"),
    //     align: "center",
    //     value: "stock_current_count",
    //   },
    // ],
    // minStockMaterialsHeaders: () => [
    //   {
    //     text: i18n.t("Top.materialsFields.material_code"),
    //     align: "start",
    //     value: "material_code",
    //   },
    //   {
    //     text: i18n.t("Top.materialsFields.material_name"),
    //     align: "start",
    //     value: "material_name",
    //   },
    //   {
    //     text: i18n.t("Top.materialsFields.stock_name"),
    //     align: "center",
    //     value: "stock.name",
    //   },
    //   {
    //     text: i18n.t("Top.materialsFields.min_stock_num"),
    //     align: "center",
    //     value: "stock_min",
    //   },
    //   {
    //     text: i18n.t("Top.materialsFields.stock_num"),
    //     align: "center",
    //     value: "stock_current_count",
    //   },
    // ],
    // neardayShopsHeaders: () => [
    //   {
    //     text: i18n.t("Top.PsiShopFields.shop_code"),
    //     align: "start",
    //     value: "shop_code",
    //   },
    //   {
    //     text: i18n.t("Top.PsiShopFields.shop_name"),
    //     align: "start",
    //     value: "shop_name",
    //   },
    //   {
    //     text: i18n.t("Top.PsiShopFields.psi_end"),
    //     align: "center",
    //     value: "psi_end",
    //   },
    //   {
    //     text: i18n.t("Top.PsiShopFields.nearday"),
    //     align: "center",
    //     value: "close_expire_days",
    //   },
    // ],
    // expiredShopsHeaders: () => [
    //   {
    //     text: i18n.t("Top.PsiShopFields.shop_code"),
    //     align: "start",
    //     value: "shop_code",
    //   },
    //   {
    //     text: i18n.t("Top.PsiShopFields.shop_name"),
    //     align: "start",
    //     value: "shop_name",
    //   },
    //   {
    //     text: i18n.t("Top.PsiShopFields.psi_end"),
    //     align: "center",
    //     value: "psi_end",
    //   },
    //   {
    //     text: i18n.t("Top.PsiShopFields.expired"),
    //     align: "center",
    //     value: "close_expire_days",
    //   },
    // ],
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["accountInfo", "settings"]),
  },

  data: () => ({
    datetimeRage: [
      new Date(new Date().getTime() - 30 * 24 * 3600 * 1000)
              .toISOString()
              .substr(0, 10),
      new Date().toISOString().substr(0, 10),
    ],
    options: JSON.parse(sessionStorage.getItem("supplier-score-options") ? sessionStorage.getItem("supplier-score-options") : JSON.stringify(defaultOptions)),
    level_num: {},
    level_score: {},
    level_satisfaction: {},
    level_qualification: {},
    level_timeliness: {},
    level_fluctuation: {},
    level_num_chart: null,
    level_satisfaction_chart: null,
    level_fluctuation_chart: null,
    level_qualification_chart: null,
    level_timeliness_chart: null,
    level_score_chart: null,
    ImportDialog: false,
    excelFile: null,
  }),

  mounted() {
    this.$commonUtils
      .loadOptions("supplier-score", [])
        .then(
          function (data) {
            if (data.options) {
              this.options = data.options;
              if (typeof this.options.finish_date_from != "undefined" && typeof this.options.finish_date_to != "undefined") {
                this.datetimeRage = [
                  this.options.finish_date_from,
                  this.options.finish_date_to,
                ];
              }
            } else this.resetSearch();
          }.bind(this)
        );
  },

  methods: {
    resetSearch() {
      this.options = JSON.parse(JSON.stringify(defaultOptions));
    },
    onSearch() {
      this.options = Object.assign({}, this.options, {});
    },
    getSupplierScoreFromAPI() {
      Suppliers.getSupplierScore(this.options).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.level_num = response.data.level_num;
            this.level_satisfaction = response.data.level_satisfaction;
            this.level_fluctuation = response.data.level_fluctuation;
            this.level_qualification = response.data.level_qualification;
            this.level_timeliness = response.data.level_timeliness;
            this.level_score = response.data.level_score;
            this.levelNumChart()
            this.levelSatisfactionChart()
            this.levelFluctuationChart()
            this.levelQualificationChart()
            this.levelTimelinessChart()
            this.levelScoreChart()
          }
        }.bind(this)
      );
    },
    levelNumChart() {
      if (this.level_num_chart != null && this.level_num_chart != "" && this.level_num_chart != undefined) {
        this.level_num_chart.dispose();//销毁
      }
      this.level_num_chart = echarts.init(document.getElementById("level_num_chart"));

      // 指定图表的配置项和数据
      let option = {
        title: {
          top: 145,
          text: i18n.t('supplierScore.level_num.total_supplier_num', [this.level_num.total_supplier_num]),
          left: 'center'
        },
        tooltip: {
          trigger: 'item'
        },
        legend: {
          top: '90%',
          left: 'center'
        },
        series: [
          {
            name: '',
            type: 'pie',
            top: -100,
            radius: ['35%', '50%'],
            color: ['#0A9A8D', '#FFA014', '#FF5E2B', '#F44A3E'],
            labelLine: {
              show: true,
            },
            label:{
              formatter: '{c}'
            },
            data: [
              { value: this.level_num.level_A_count, name: i18n.t("supplierScore.A") },
              { value: this.level_num.level_B_count, name: i18n.t("supplierScore.B") },
              { value: this.level_num.level_C_count, name: i18n.t("supplierScore.C") },
              { value: this.level_num.level_D_count, name: i18n.t("supplierScore.D") },
            ]
          }
        ]
      };

      // 使用刚指定的配置项和数据显示图表。
      this.level_num_chart.setOption(option);
    },
    levelSatisfactionChart() {
      if (this.level_satisfaction_chart != null && this.level_satisfaction_chart != "" && this.level_satisfaction_chart != undefined) {
        this.level_satisfaction_chart.dispose();//销毁
      }
      this.level_satisfaction_chart = echarts.init(document.getElementById("level_satisfaction_chart"));

      // 指定图表的配置项和数据
      let option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        xAxis: {
          type: 'category',
          data: [i18n.t('supplierScore.A'), i18n.t('supplierScore.B'), i18n.t('supplierScore.C'), i18n.t('supplierScore.D')]
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            type: 'bar',
            data: [
              {
                value: this.level_satisfaction.level_A_satisfaction_avg ? (this.level_satisfaction.level_A_satisfaction_avg * 100).toFixed(2) : 0,
                itemStyle: {
                  color: '#0A9A8D'
                }
              },
              {
                value: this.level_satisfaction.level_B_satisfaction_avg ? (this.level_satisfaction.level_B_satisfaction_avg * 100).toFixed(2) : 0,
                itemStyle: {
                  color: '#FFA014'
                }
              },
              {
                value: this.level_satisfaction.level_C_satisfaction_avg ? (this.level_satisfaction.level_C_satisfaction_avg * 100).toFixed(2) : 0,
                itemStyle: {
                  color: '#FF5E2B'
                }
              },
              {
                value: this.level_satisfaction.level_D_satisfaction_avg ? (this.level_satisfaction.level_D_satisfaction_avg * 100).toFixed(2) : 0,
                itemStyle: {
                  color: '#F44A3E'
                }
              },
            ]
          }
        ]
      };

      // 使用刚指定的配置项和数据显示图表。
      this.level_satisfaction_chart.setOption(option);
    },
    levelFluctuationChart() {
      if (this.level_fluctuation_chart != null && this.level_fluctuation_chart != "" && this.level_fluctuation_chart != undefined) {
        this.level_fluctuation_chart.dispose();//销毁
      }
      this.level_fluctuation_chart = echarts.init(document.getElementById("level_fluctuation_chart"));

      // 指定图表的配置项和数据
      let option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        xAxis: {
          type: 'category',
          data: [i18n.t('supplierScore.A'), i18n.t('supplierScore.B'), i18n.t('supplierScore.C'), i18n.t('supplierScore.D')]
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            type: 'bar',
            data: [
              {
                value: this.level_fluctuation.level_A_fluctuation_avg ? this.level_fluctuation.level_A_fluctuation_avg : 0,
                itemStyle: {
                  color: '#0A9A8D'
                }
              },
              {
                value: this.level_fluctuation.level_B_fluctuation_avg ? this.level_fluctuation.level_B_fluctuation_avg : 0,
                itemStyle: {
                  color: '#FFA014'
                }
              },
              {
                value: this.level_fluctuation.level_C_fluctuation_avg ? this.level_fluctuation.level_C_fluctuation_avg : 0,
                itemStyle: {
                  color: '#FF5E2B'
                }
              },
              {
                value: this.level_fluctuation.level_D_fluctuation_avg ? this.level_fluctuation.level_D_fluctuation_avg : 0,
                itemStyle: {
                  color: '#F44A3E'
                }
              },
            ]
          }
        ]
      };

      // 使用刚指定的配置项和数据显示图表。
      this.level_fluctuation_chart.setOption(option);
    },
    levelQualificationChart() {
      if (this.level_qualification_chart != null && this.level_qualification_chart != "" && this.level_qualification_chart != undefined) {
        this.level_qualification_chart.dispose();//销毁
      }
      this.level_qualification_chart = echarts.init(document.getElementById("level_qualification_chart"));

      // 指定图表的配置项和数据
      let option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        xAxis: {
          type: 'category',
          data: [i18n.t('supplierScore.A'), i18n.t('supplierScore.B'), i18n.t('supplierScore.C'), i18n.t('supplierScore.D')]
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            type: 'bar',
            data: [
              {
                value: this.level_qualification.level_A_qualification_avg ? (this.level_qualification.level_A_qualification_avg * 100).toFixed(2) : 0,
                itemStyle: {
                  color: '#0A9A8D'
                }
              },
              {
                value: this.level_qualification.level_B_qualification_avg ? (this.level_qualification.level_B_qualification_avg * 100).toFixed(2) : 0,
                itemStyle: {
                  color: '#FFA014'
                }
              },
              {
                value: this.level_qualification.level_C_qualification_avg ? (this.level_qualification.level_C_qualification_avg * 100).toFixed(2) : 0,
                itemStyle: {
                  color: '#FF5E2B'
                }
              },
              {
                value: this.level_qualification.level_D_qualification_avg ? (this.level_qualification.level_D_qualification_avg * 100).toFixed(2) : 0,
                itemStyle: {
                  color: '#F44A3E'
                }
              },
            ]
          }
        ]
      };

      // 使用刚指定的配置项和数据显示图表。
      this.level_qualification_chart.setOption(option);
    },
    levelTimelinessChart() {
      if (this.level_timeliness_chart != null && this.level_timeliness_chart != "" && this.level_timeliness_chart != undefined) {
        this.level_timeliness_chart.dispose();//销毁
      }
      this.level_timeliness_chart = echarts.init(document.getElementById("level_timeliness_chart"));

      // 指定图表的配置项和数据
      let option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        xAxis: {
          type: 'category',
          data: [i18n.t('supplierScore.A'), i18n.t('supplierScore.B'), i18n.t('supplierScore.C'), i18n.t('supplierScore.D')]
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            type: 'bar',
            data: [
              {
                value: this.level_timeliness.level_A_timeliness_avg ? (this.level_timeliness.level_A_timeliness_avg * 100).toFixed(2) : 0,
                itemStyle: {
                  color: '#0A9A8D'
                }
              },
              {
                value: this.level_timeliness.level_B_timeliness_avg ? (this.level_timeliness.level_B_timeliness_avg * 100).toFixed(2) : 0,
                itemStyle: {
                  color: '#FFA014'
                }
              },
              {
                value: this.level_timeliness.level_C_timeliness_avg ? (this.level_timeliness.level_C_timeliness_avg * 100).toFixed(2) : 0,
                itemStyle: {
                  color: '#FF5E2B'
                }
              },
              {
                value: this.level_timeliness.level_D_timeliness_avg ? (this.level_timeliness.level_D_timeliness_avg * 100).toFixed(2) : 0,
                itemStyle: {
                  color: '#F44A3E'
                }
              },
            ]
          }
        ]
      };

      // 使用刚指定的配置项和数据显示图表。
      this.level_timeliness_chart.setOption(option);
    },
    levelScoreChart() {
      if (this.level_score_chart != null && this.level_score_chart != "" && this.level_score_chart != undefined) {
        this.level_score_chart.dispose();//销毁
      }
      this.level_score_chart = echarts.init(document.getElementById("level_score_chart"));

      // 指定图表的配置项和数据
      let option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        xAxis: {
          type: 'category',
          data: [i18n.t('supplierScore.A'), i18n.t('supplierScore.B'), i18n.t('supplierScore.C'), i18n.t('supplierScore.D')]
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            type: 'bar',
            data: [
              {
                value: this.level_score.level_A_score_avg ? this.level_score.level_A_score_avg : 0,
                itemStyle: {
                  color: '#0A9A8D'
                }
              },
              {
                value: this.level_score.level_B_score_avg ? this.level_score.level_B_score_avg : 0,
                itemStyle: {
                  color: '#FFA014'
                }
              },
              {
                value: this.level_score.level_C_score_avg ? this.level_score.level_C_score_avg : 0,
                itemStyle: {
                  color: '#FF5E2B'
                }
              },
              {
                value: this.level_score.level_D_score_avg ? this.level_score.level_D_score_avg : 0,
                itemStyle: {
                  color: '#F44A3E'
                }
              },
            ]
          }
        ]
      };

      // 使用刚指定的配置项和数据显示图表。
      this.level_score_chart.setOption(option);
    },
    exports() {
      let options = JSON.parse(JSON.stringify(this.options));
      Suppliers.supplierScoreExport(options);
    },
    importExcel() {
      this.$store.dispatch("fullscreenLoading");
      Suppliers.supplierComplaintImport(this.excelFile)
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.$snackbar.info(i18n.t("Import.success", [i18n.t("supplierScore.qualification")]));
              this.ImportDialog = false;
              this.getSupplierScoreFromAPI();
            }
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        ).catch(
          function () {
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
      );
    },
  },
  watch: {
    options: {
      deep: true,
      handler() {
        this.getSupplierScoreFromAPI();
        sessionStorage.setItem("supplier-score-options", JSON.stringify(this.options));
      },
    },
    datetimeRage: {
      handler() {
        if (this.datetimeRage[0] == null || this.datetimeRage[0] == "") {
          this.options.finish_date_from = new Date(new Date().getTime() - 30 * 24 * 3600 * 1000).toISOString().substr(0, 10);
        } else {
          this.options.finish_date_from = this.datetimeRage[0];
        }

        if (this.datetimeRage[1] == null || this.datetimeRage[1] == "") {
          this.options.finish_date_to = new Date().toISOString().substr(0, 10);
        } else {
          this.options.finish_date_to = this.datetimeRage[1];
        }
      },
    },
    level_num: {
      handler() {
        if (!this.level_num) {
          this.levelNumChart()
        }
      }
    }
  },
};
</script>
